import { Component, inject } from '@angular/core';
import { HeaderComponent } from '../../core/shared/layout/header/header.component';
import { BottomNavigationComponent } from '../../core/shared/layout/bottom-navigation/bottom-navigation.component';
import { FooterComponent } from '../../core/shared/layout/footer/footer.component';
import { UserService } from '../../core/services/user/user.service';
import { AsyncPipe, NgClass, NgForOf, NgIf, NgStyle, NgTemplateOutlet } from '@angular/common';
import { TranslatePipe } from '../../core/shared/translation/translate.pipe';
import { SideNavComponent } from '../../core/shared/layout/side-nav/side-nav.component';
import { UserResultsService } from '../../core/services/user/user-results.service';
import { ProgressBarComponent } from '../../core/shared/components/progress-bar/progress-bar.component';
import { LoyaltyService } from '../../core/services/loyalty/loyalty.service';
import { SafePipe } from '../../core/shared/pipes/safe.pipe';
import { SetImgAltDirective } from '../../core/shared/directives/set-img-alt.directive';
import { ArabicService } from '../../core/services/arabic.service';
import { isMobile } from '../../core/helpers/device';
import { SliderComponent } from '../../core/modules/slider/slider.component';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'app-user-results',
  imports: [
    HeaderComponent,
    SideNavComponent,
    BottomNavigationComponent,
    FooterComponent,
    TranslatePipe,
    NgTemplateOutlet,
    ProgressBarComponent,
    AsyncPipe,
    NgForOf,
    NgIf,
    SafePipe,
    SetImgAltDirective,
    NgClass,
    NgStyle,
    SliderComponent,
    RouterLink,
  ],
  templateUrl: './user-results.component.html',
  styleUrl: './user-results.component.scss',
})
export class UserResultsComponent {
  public results = inject(UserResultsService);
  public user = inject(UserService);
  public loyalty = inject(LoyaltyService);
  public aeService = inject(ArabicService);
  protected readonly isMobile = isMobile;

  /**
   * Slider config
   */
  public sliderConfig = {
    breakpoints: {
      '(max-width: 768px)': {
        slides: {
          perView: 1.3,
          spacing: 20,
          origin: 'auto',
        },
      },
      '(max-width: 325px)': {
        slides: {
          perView: 1.2,
          spacing: 20,
          origin: 'auto',
        },
      },
      // '(max-width: 992px)': {
      //   slidesPerView: 1.8,
      //   centered: false,
      //   spacing: 20,
      // }
    },
    loop: true,
  };
}
